import { useState, useEffect } from "react"
import API_KEY from "./keys"

const CONTEXT_KEY = '2552c82c7be36fe9a'
// const CONTEXT_KEY = '707ed3c1e6d398bea'

const useGoogleSearch = (term) => {
    const [data, setData] = useState(null)

    useEffect(() => {
        const fetchData = async () => {
            fetch(
                `https://www.googleapis.com/customsearch/v1?key=${API_KEY}&cx=${CONTEXT_KEY}&q=${term}`
            )
                .then((response) => response.json())
                .then((result) => {
                    setData(result)
                })
        }
        fetchData()
    }, [term])
    return { data }
}

export default useGoogleSearch
